<template>
    <employees-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <employee-contract-edit-form :disabled="_.itemDisabled" v-model="_.item" />
        </sub-item-show-view>
    </employees-show-page>
</template>

<script>
    import EmployeesShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import EmployeeContractEditForm from './Shared/EmployeeContractEditForm'

    export default {
        name: 'EmployeesShowContractsEditPage',
        inheritAttrs: false,
        components: {
            EmployeesShowPage,
            SubItemShowView,
            EmployeeContractEditForm,
        },
    }
</script>

<style scoped>

</style>